{
  "headingLocationSpecific": "Top-Immobilienagenturen in {location}",
  "seo.pageDescriptionLocationSpecific": "Suche und vergleiche die besten Immobilienagenturen in {location}. Kontaktiere Agenturen in deiner Nähe und finde dein passendes Zuhause!",
  "seo.pageTitleLocationSpecific": "Beste Immobilienagenturen in {location} – Objekte mieten & kaufen {'|'} ImmoScout24",
  "seo.pageTitleWithPageLocationSpecific": "Seite {page} - Alle Top-Immobilienagenturen in {location} | ImmoScout24"
}